export const TABS = {
  DASHBOARD: "dashboard",
  FUNDING_ROUNDS: "funding-rounds",
  SIGNAL: "signal",
  // INVESTMENT_TRENDS: "investment-trends",
  INVESTORS: "investors",
  UNICORNS: "unicorns",
  PEOPLE: "people",
  PROFILE: "profile",
};
  